/**
 * Extracts query parameters from URLSearchParams and groups multiple values for the same key.
 * @param searchParams - The URLSearchParams object to extract from
 * @returns An object where each key is a parameter name and the value is an array of parameter values
 */
export function extractExistingParams(searchParams: URLSearchParams): Record<string, string[]> {
  const entries = Array.from(searchParams.entries());

  return entries.reduce((result: Partial<Record<string, string[]>>, [key, value]) => {
    if (!result[key]) {
      result[key] = [];
    }
    result[key].push(value);
    return result;
  }, {}) as Record<string, string[]>;
}
